/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} During_This_EventInputs */

const en_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`During this event`)
};

const ar_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خلال هذا الحدث`)
};

const de_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Während dieses Events`)
};

const es_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durante este evento`)
};

const fr_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendant cet événement`)
};

const it_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durante questo evento`)
};

const ja_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本イベント期間中`)
};

const ko_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이번 이벤트 기간 동안`)
};

const pt_br_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durante este evento`)
};

const ru_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Во время этого события`)
};

const th_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ในช่วงเวลากิจกรรมนี้`)
};

const tr_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu etkinlik sırasında`)
};

const zh_cn_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本次活动期间`)
};

const zh_tw_during_this_event = /** @type {(inputs: During_This_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本次活動期間`)
};

/**
* | output |
* | --- |
* | "During this event" |
*
* @param {During_This_EventInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const during_this_event = /** @type {((inputs?: During_This_EventInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<During_This_EventInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_during_this_event(inputs)
	if (locale === "ar") return ar_during_this_event(inputs)
	if (locale === "de") return de_during_this_event(inputs)
	if (locale === "es") return es_during_this_event(inputs)
	if (locale === "fr") return fr_during_this_event(inputs)
	if (locale === "it") return it_during_this_event(inputs)
	if (locale === "ja") return ja_during_this_event(inputs)
	if (locale === "ko") return ko_during_this_event(inputs)
	if (locale === "pt_br") return pt_br_during_this_event(inputs)
	if (locale === "ru") return ru_during_this_event(inputs)
	if (locale === "th") return th_during_this_event(inputs)
	if (locale === "tr") return tr_during_this_event(inputs)
	if (locale === "zh_cn") return zh_cn_during_this_event(inputs)
	return zh_tw_during_this_event(inputs)
});